// TODO: this mixins and all mixins in this directory need to be refactored into respective filter and table mixins once BaseLevelFilterModule and BaseLevelTable are used in BaseLevelTableModule
// services
import baseLevelTableService
  from '@/components/view_root_components/base_level_table_module/services/base-level-table-service';
import configurableTableColumnMixin from '@/components/view_root_components/base_level_table_module/mixins/configurable-table-column-mixin'
// store
import { mapActions, mapGetters } from 'vuex';
import formUtils from '@/utils/form-utils';
// helpers
import TableDataKeys from "../../../base_components/tables/enum/table-data-keys";
import fetchExcelDataMixin from '@/components/global_components/tables/mixins/fetch-excel-data-mixin';
import fetchZipDataMixin from '@/components/global_components/tables/mixins/fetch-zip-data-mixin';
import exportCsvDataMixin from '@/components/global_components/tables/mixins/export-csv-data-mixin';
import exportExcelDataMixin from '@/components/global_components/tables/mixins/export-excel-data-mixin';
import exportZipDataMixin from '@/components/global_components/tables/mixins/export-zip-data-mixin';

export default function (props, featureFlagProps, dataHandlerMixin) {
  return {
    props: {
      ...props,
      ...featureFlagProps,
    },
    mixins: [
      dataHandlerMixin,
      configurableTableColumnMixin,
      fetchExcelDataMixin(
        self => self.notVisibleHeaders,
        self => self.getTable(self.$route, self.tableIdentifier)?.[TableDataKeys.BULK_IDS],
        self => self.getTable(self.$route, self.tableIdentifier)?.[TableDataKeys.EXCLUDE_IDS_SELECTION_MODE]
      ),
      fetchZipDataMixin(
        self => self.getTable(self.$route, self.tableIdentifier)?.[TableDataKeys.BULK_IDS],
        self => self.getTable(self.$route, self.tableIdentifier)?.[TableDataKeys.EXCLUDE_IDS_SELECTION_MODE],
        self => self.name
      ),
      exportCsvDataMixin(
        self => self.notVisibleHeaders,
        self => self.getTable(self.$route, self.tableIdentifier)?.[TableDataKeys.BULK_IDS],
        self => self.getTable(self.$route, self.tableIdentifier)?.[TableDataKeys.EXCLUDE_IDS_SELECTION_MODE]
      ),
      exportExcelDataMixin,
      exportZipDataMixin,
    ],
    computed: {
      ...mapGetters('presetStore', ['getPresetsFor']),
      ...mapGetters('tableStore', ['getTable']),
      availablePresets() {
        return this.getPresetsFor(this.concept);
      },
      tableExists() {
        return this.tableNotCachedYet() === false;
      },
      internalHeaders() {
        if (this.configurableColumns != undefined) {
          const mappedColumns = this._getMappedconfigurableColumns(
            this.configurableColumns
          );
          const prepend = mappedColumns.filter(
            (col) => this.prependConfigurableColumns.includes(col.value)
          );
          const append = mappedColumns.filter(
            (col) => !this.prependConfigurableColumns.includes(col.value)
          );

          return [...prepend, ...this.headers, ...append];
        }
        return this.headers;
      }
    },
    methods: {
      ...mapActions('routingHistory', ['redirectToLastHistoryObject']),
      invokeHandleRowClick(event) {
        if (this.handleClickRow === undefined) {
          return this.openForm(event)
        } else return this.handleClickRow(event)
      },
      openForm(item) {
        if (!this.customOpenForm) {
          let id = item.id;
          this.$router
            .push({ name: this.formComponent, params: { id } })
            .catch(() => { });
        } else {
          this.customOpenForm(item);
        }
      },
      invokeNewAction() {
        if (this.handleNewSpecificAction != undefined) {
          return this.handleNewSpecificAction(this._openNewDefault)
        }
        return this._openNewDefault();
      },
      _openNewDefault(param) {
        if (!this.customOpenNewDefault) {
          this.$router.push({
            name: this.formComponent,
            params: { id: formUtils.createNewIdentifier(), ...param }
          });
        } else {
          this.customOpenNewDefault(param);
        }
      },
      invokeHandleFilterChange(val) {
        this.handleFilterChange(val);
      },
      async getDefaultPreset() {
        await baseLevelTableService.invokeLoadOfPresetsFor(this.concept);
        const availablePresets = await this.getPresetsFor(this.concept);
        return baseLevelTableService.getDefaultPrestOf(availablePresets);
      },
      async loadPresetsAndSetDefault(setDefault = true) {
        if (!this.allowPresets)
          return;

        const defaultPreset = await this.getDefaultPreset();

        if (setDefault && defaultPreset != undefined) {
          await this.setCachedExistingPreset(defaultPreset, this.tableIdentifier);
        }
      },
    },
  }
}
